import React from 'react';
import { HomeOutlined, StarOutlined, ApiOutlined, GlobalOutlined, NotificationOutlined } from '@ant-design/icons';
import MagicIcon from '../../svg/MagicIcon';
import { Tag } from 'antd';

/**
 * Static menu items for the main navigation
 */
export const menuItems = [
  {
    key: 'home',
    icon: <HomeOutlined />,
    label: 'Home',
  },
  // {
  //   label: 'Integrations',
  //   key: 'integrations',
  //   icon: <ProductOutlined />,
  // },
  {
    label: 'Starred',
    key: 'starred',
    icon: <StarOutlined />,
  },
  {
    label: 'API Files',
    key: 'api',
    icon: <ApiOutlined />,
  },
  {
    label: (
      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        Onedoc AI
        <Tag
          style={{
            borderRadius: '15px',
            backgroundColor: '#f0f0f0',
            color: '#000',
            fontWeight: 'bold',
            padding: '0 8px',
            fontSize: '0.75rem',
          }}
        >
          Beta
        </Tag>
      </span>
    ),
    key: 'chat',
    icon: <MagicIcon width={'14'} height={'14'} />,
  },
  {
    label: 'Announcements',
    key: 'announcement',
    icon: <NotificationOutlined />,
  },
  {
    label: 'Onedoc Sites',
    key: 'onedoc-sites',
    icon: <GlobalOutlined />,
  },
  // {
  //   key: 'documents',
  //   icon: <FileTextOutlined />,
  //   label: 'Documents',
  // },
  // {
  //   key: 'projects',
  //   icon: <FolderOutlined />,
  //   label: 'Projects',
  // },
  // {
  //   key: 'settings',
  //   icon: <SettingOutlined />,
  //   label: 'Settings',
  // },
];
